import type { Theme } from '../hooks/useTheme';

interface ThemeToggleProps {
  theme: Theme;
  onToggle: () => void;
}

export function ThemeToggle({ theme, onToggle }: ThemeToggleProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label="Toggle colour theme"
      aria-pressed={theme === 'light'}
      className="relative h-[30px] w-14 flex-none cursor-pointer rounded-full border border-[var(--line)] bg-[var(--card)] p-0"
    >
      <span
        className="absolute left-[3px] top-[3px] h-[22px] w-[22px] rounded-full bg-accent shadow-[0_0_12px_rgba(208,119,24,0.6)] transition-transform duration-[350ms] ease-[cubic-bezier(0.6,0.05,0.2,1)]"
        style={{ transform: `translateX(var(--knob))` }}
      />
    </button>
  );
}
